import React from 'react';
import { ClampText } from '@wix/wix-vod-shared/components';
import PropTypes from 'prop-types';

const defaultClampOptions = {
  lineClamp: 2,
};

const Title = ({ text, clampOptions = {}, enforceJSClamp, tag = 'h3' }) => (
  <ClampText
    text={text}
    dataHook="title"
    wrapperTag={tag}
    enforceJSClamp={enforceJSClamp}
    clampOptions={{ ...defaultClampOptions, ...clampOptions }}
  />
);

Title.propTypes = {
  text: PropTypes.string,
  clampOptions: PropTypes.object,
  enforceJSClamp: PropTypes.bool,
};

export default Title;
